import React, { useState } from "react"
import PropTypes from "prop-types"
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
} from "common/CustomCollapsable"
import ExpandMoreIcon from "@mui/icons-material/ExpandMore"
import { Typography } from "@mui/material"

const Collapsable = ({
  title,
  expanded: expandedProp,
  onChange,
  disabled,
  iconPosition,
  children,
}) => {
  const [internalExpanded, setInternalExpanded] = useState(
    expandedProp !== undefined ? expandedProp : false,
  )
  const isControlled = expandedProp !== undefined
  const expanded = isControlled ? expandedProp : internalExpanded

  const handleChange = () => {
    if (!isControlled) {
      setInternalExpanded(!internalExpanded)
    }
    if (onChange) {
      onChange(!expanded)
    }
  }

  return (
    <Accordion expanded={expanded} onChange={handleChange} disabled={disabled}>
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        iconPosition={iconPosition}
      >
        {typeof title === "string" ? (
          <Typography
            variant="h6"
            component="h2"
            sx={{ fontWeight: 300, fontSize: 16 }}
          >
            {title}
          </Typography>
        ) : (
          title
        )}
      </AccordionSummary>
      <AccordionDetails>{children}</AccordionDetails>
    </Accordion>
  )
}

Collapsable.propTypes = {
  title: PropTypes.node,
  expanded: PropTypes.bool,
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
  iconPosition: PropTypes.oneOf(["left", "right"]),
  children: PropTypes.node.isRequired,
}

Collapsable.defaultProps = {
  title: "",
  expanded: undefined,
  onChange: null,
  iconPosition: "left",
  disabled: false,
}

export default Collapsable
